import { render, staticRenderFns } from "./TechnologyPartners.vue?vue&type=template&id=1f031b49"
import script from "./TechnologyPartners.vue?vue&type=script&lang=js"
export * from "./TechnologyPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports